import { render, staticRenderFns } from "./OrdersMobile.vue?vue&type=template&id=2eb5e776&scoped=true"
import script from "./OrdersMobile.vue?vue&type=script&lang=ts"
export * from "./OrdersMobile.vue?vue&type=script&lang=ts"
import style0 from "./OrdersMobile.vue?vue&type=style&index=0&id=2eb5e776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb5e776",
  null
  
)

export default component.exports